export const defaultSizePerPage = [{
  text: "10", value: 10
}, {
  text: "25", value: 25
}, {
  text: "50", value: 50
}, {
  text: "100", value: 100
}]